import React from 'react';
import { Multiselect } from '@amzn/awsui-components-react-v3';
import { REPORT_TYPE } from '../../constants/report_type';
import { AccuracyButtonNewStyle } from '../../styles/common_styles';
import {findOptions} from "../reports/utils/buttons";

export class ComponentsButton extends React.Component {

  getDropdownOptions = (components, selectedParentComponents) => {
    if(this.props.reportType.toUpperCase() === REPORT_TYPE.FORECAST) {
      components = components.filter((c) => c.hasBaseFactor === true);
    }
    return components.map((c) => {
      return {
        value: c.id,
        label: c.label,
        disabled:
          selectedParentComponents &&
          selectedParentComponents.length &&
          !selectedParentComponents.some((item) => c.id.startsWith(item)),
      };
    });
  };

  getSelectedParentComponents = () => {
    const { extractParentComponent, selected } = this.props;
    return [...new Set(selected.map((item) => extractParentComponent(item)))];
  };

  render() {
    const selectedParentComponents = this.getSelectedParentComponents();
    const options = this.getDropdownOptions(this.props.components, selectedParentComponents);

    return (
      <div className={AccuracyButtonNewStyle}>
        <b> {this.props.text} </b>
        <Multiselect
          options={options}
          filteringType="auto"
          placeholder={this.props.text}
          onChange={this.props.onChange}
          selectedOptions={findOptions(options, this.props.selected)}
          statusType={!this.props.components ? 'loading' : 'finished'}
          loadingText="Loading components..."          
          data-cy={this.props['data-cy']}          
        />
      </div>
    );
  }

  static defaultProps = {
    'data-cy': 'component-button',
  };
}



// WEBPACK FOOTER //
// ./src/components/buttons/components_button.jsx